import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-hr-attendance-fui',
  templateUrl: './hr-attendance-fui.component.html',
  styleUrls: ['./hr-attendance-fui.component.scss']
})
export class HrAttendanceFuiComponent implements OnInit {

  employees: any[] = [];
  selectedEmpId: number | null = null;

  fromDate: string = '';
  toDate: string = '';

  logs: any[] = [];
  summary: any[] = [];

  isLoading: boolean = false;

  totalDays: number = 0;
  totalMinutes: number = 0;
  avgMinutesPerDay: number = 0;

  employeeSearch: string = '';

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadEmployees();
    const today = new Date();
    const iso = today.toISOString().substring(0, 10);
    this.fromDate = iso;
    this.toDate = iso;
  }

  get filteredEmployees(): any[] {
    const term = (this.employeeSearch || '').toLowerCase();
    if (!term) {
      return this.employees;
    }
    return this.employees.filter(e => {
      const idText = ('' + e.empId).toLowerCase();
      const nameText = (e.empName || '').toLowerCase();
      return idText.includes(term) || nameText.includes(term);
    });
  }

  selectEmployeeFromSearch(emp: any): void {
    this.selectedEmpId = emp.empId;
    this.employeeSearch = emp.empId + ' - ' + (emp.empName || '');
    this.refresh();
  }

  onEmployeeChange(event: any): void {
    this.refresh();
  }

  loadEmployees(): void {
    this.apiService.getEmployees().subscribe((data: any) => {
      this.employees = data;
    });
  }

  refresh(): void {
    if (!this.selectedEmpId || !this.fromDate || !this.toDate) {
      return;
    }

    this.isLoading = true;

    this.apiService.getAttendanceSummary(this.selectedEmpId, this.fromDate, this.toDate)
      .subscribe((summary: any[]) => {
        this.summary = summary || [];
        this.computeTopSummary();
      });

    this.apiService.getAttendanceLogs(this.selectedEmpId, this.fromDate, this.toDate)
      .subscribe((logs: any[]) => {
        this.logs = logs || [];
        this.isLoading = false;
      }, _ => {
        this.isLoading = false;
      });
  }

  private computeTopSummary(): void {
    this.totalDays = this.summary.length;
    this.totalMinutes = this.summary.reduce((acc, s) => acc + (s.totalMinutes || 0), 0);
    this.avgMinutesPerDay = this.totalDays > 0 ? Math.round(this.totalMinutes / this.totalDays) : 0;
  }

  toHours(minutes: number): string {
    if (!minutes) {
      return '0.0';
    }
    return (minutes / 60).toFixed(1);
  }
}
